<app-menu
  #menu
  [direction]="direction"
  class="ui-button-bare-neutral"
  [depth]="10000"
  [icon]="icon"
  [iconColor]="iconColor"
  [iconSize]="iconSize"
  [label]="label"
  [labelStyle]="_labelStyle"
  [iconFirst]="iconFirst"
  [hideOnAnyUserInteraction]="true"
  [backgroundColor]="backgroundColor"
  [exclusive]="false"
  (showMenu)="onShowMenu()"
  [ngStyle]="_menuStyle"
  ><div [ngStyle]="_tooltipStyle"><ng-content></ng-content></div
></app-menu>
